<template>
    <a href="#"
       class="btn-flag"
       @click.prevent="$emit('change',lang)"
    >
        <div class="losange" :class="'flag-'+lang"></div>
        {{this.trads[this.lang]}}
    </a>
</template>

<script>
    export default {
        name: "BtnFlag",
        props:{
            "lang":{
                type:String,
                default:"fr"
            }
        },
        data() {
            return {
                trads:{
                    "fr":"Français",
                    "mg":"Malgache",
                    "en":"English",
                }
            }
        },
        computed:{
        }
    }
</script>

<style lang="less">
    .btn-flag{
        text-decoration: none;
        display: inline-flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        margin: 0vw 3.5vw;
        color: #fff;
        &.active{
            font-weight: bold;
        }
        .losange{
            pointer-events: none;
            width: 5vw;
            height: 5vw;
            position: relative;
            margin-bottom: 2vw;
            background-size: cover;
            &.flag-fr{
                background-image: url("./flag-fr.png");
            }
            &.flag-mg{
                background-image: url("./flag-mg.png");
            }
            &.flag-en{
                background-image: url("./flag-en.png");
            }
        }


    }
</style>